class ProductComplementaryProducts extends HTMLElement {
  static get observedAttributes() {
    return ['data-url']
  }

  connectedCallback() {
    this._syncFromDom()
    this.loadComplementaryProducts()
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // Skip the initial attribute assignment; connectedCallback handles first load.
    if (
      name !== 'data-url' ||
      oldValue === null ||
      oldValue === newValue ||
      !this.isConnected
    ) {
      return
    }

    this.complementaryUrl = newValue
    this.complementaryContainer =
      this.complementaryContainer ||
      this.querySelector('[data-complementary-container]')
    this.loadComplementaryProducts()
  }

  _syncFromDom() {
    this.complementaryUrl = this.getAttribute('data-url')
    this.complementaryContainer = this.querySelector(
      '[data-complementary-container]',
    )
  }

  loadComplementaryProducts() {
    if (!this.complementaryUrl || !this.complementaryContainer) return

    const requestUrl = this.complementaryUrl

    fetch(requestUrl)
      .then((response) => response.text())
      .then((text) => {
        // Ignore stale responses if the product changed again mid-fetch.
        if (
          !this.complementaryContainer ||
          this.complementaryUrl !== requestUrl
        ) {
          return
        }

        const html = new DOMParser().parseFromString(text, 'text/html')
        const complementaryContent = html.querySelector(
          '[data-complementary-container]',
        )
        if (complementaryContent) {
          this.complementaryContainer.innerHTML = complementaryContent.innerHTML
        }
      })
  }
}

customElements.define('product-complementary-products', ProductComplementaryProducts)
